webpackJsonp([130639229982840],{

/***/ 1203:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0030_vigor_adept.jpg","type":"Unit","subtype":"Monk","cost":4,"ATK":5,"HP":5,"rules_text_1":"Frenzy 1 (Gets +1 ATK on your turn.)","rules_text_2":"Readiness (Doesn't exhaust to attack, but can only attack once per turn.)","rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Vigor Adept","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"White","spec":"Discipline","bottom":"Tech II","rulings":[],"keywords":["Frenzy X","Readiness"],"slug":"vigor_adept"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"vigor_adept","keywords":["Frenzy X","Readiness"],"imageRegex":"/vigor_adept.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-vigor-adept-eac8d34b62ac656499ab.js